var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3612 2.48148C18.2872 1.40754 16.5461 1.40753 15.4721 2.48148L13.9323 4.0213L6.68515 11.2684C6.56767 11.3859 6.48433 11.5332 6.44404 11.6943L5.52737 15.361C5.44927 15.6734 5.5408 16.0038 5.76848 16.2314C5.99616 16.4591 6.32661 16.5507 6.63899 16.4726L10.3056 15.5559C10.4669 15.5156 10.614 15.4323 10.7315 15.3148L17.926 8.12038L19.5185 6.52784C20.5925 5.4539 20.5925 3.71269 19.5185 2.63876L19.3612 2.48148ZM16.7685 3.77784C17.1264 3.41987 17.7069 3.41987 18.0648 3.77784L18.2221 3.93511C18.5801 4.2931 18.5801 4.87351 18.2221 5.23148L17.2903 6.16329L15.8646 4.68179L16.7685 3.77784ZM14.5679 5.97838L15.9937 7.45989L9.61473 13.8389L7.67651 14.3235L8.16105 12.3853L14.5679 5.97838ZM3.66667 7.3333C3.66667 6.82704 4.07708 6.41663 4.58333 6.41663H9.16667C9.67294 6.41663 10.0833 6.00623 10.0833 5.49997C10.0833 4.99371 9.67294 4.5833 9.16667 4.5833H4.58333C3.06455 4.5833 1.83333 5.81452 1.83333 7.3333V17.4166C1.83333 18.9354 3.06455 20.1666 4.58333 20.1666H14.6667C16.1855 20.1666 17.4167 18.9354 17.4167 17.4166V12.8333C17.4167 12.3271 17.0063 11.9166 16.5 11.9166C15.9937 11.9166 15.5833 12.3271 15.5833 12.8333V17.4166C15.5833 17.9229 15.1729 18.3333 14.6667 18.3333H4.58333C4.07708 18.3333 3.66667 17.9229 3.66667 17.4166V7.3333Z",
    fill: "#E73529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ea6cea5ffcc535df01a93d86f26d8670.svg";
export { ForwardRef as ReactComponent };